// extracted by mini-css-extract-plugin
export default {"articleTitle":"companyStructure_articleTitle__id13y","pictureContainer":"companyStructure_pictureContainer__dfPSW"};